import { Injectable } from '@angular/core';
import { GlobalComponent } from 'src/app/global-component';

interface Event {
    type: string;
    payload?: any;
}

@Injectable({
    providedIn: 'root'
})


export class DefaultImageService {

    static loadedImageUrls: { fullname: string, imgUrl: any }[] = []; // if fullname has been mapped - we save it for future, to avoid regen the intitials. 

    public getDefaultUserImage(fullname?: string) {

        return GlobalComponent.defaultUserImage;

        //Image Generation Disabled - Add flag to environment - put in Settings 

        // if (fullname == undefined) {
        //     return GlobalComponent.defaultUserImage;
        // }

        // if (fullname.trim().length === 0) {
        //     return GlobalComponent.defaultUserImage;
        // }

        // return this.generateAvatar(fullname);
    }

    public getDefaultMyfileImage() {
        return GlobalComponent.defaultDocumentImageUrl;
    }

    checkIfInitialsAlreadyHaveBeenGenerated(initials: string) {
        var index = DefaultImageService.loadedImageUrls.findIndex(x => x.fullname === initials);

        if (index >= 0) {
            return DefaultImageService.loadedImageUrls[index].imgUrl;
        }

        return undefined;
    }

    private generateAvatar(fullname: string) {

        var imageUrl = this.checkIfInitialsAlreadyHaveBeenGenerated(fullname);

        if (imageUrl == undefined) {
            var initials = fullname.split(' ').map(function (str) { return str ? str[0].toUpperCase() : ""; }).join('').slice(0, 2);
            var canvas = document.createElement('canvas');
            var radius = 30;
            var margin = 5;
            canvas.width = radius * 2 + margin * 2;
            canvas.height = radius * 2 + margin * 2;

            // Get the drawing context
            var ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.beginPath();
                ctx.arc(radius + margin, radius + margin, radius, 0, 2 * Math.PI, false);
                ctx.closePath();
                ctx.fillStyle = 'grey';
                ctx.fill();
                ctx.fillStyle = "white";
                ctx.font = " 30px Arial";
                ctx.textAlign = 'center';
                ctx.fillText(initials, radius + 5, radius * 4 / 3 + margin);
            }
            DefaultImageService.loadedImageUrls.push({fullname: fullname, imgUrl: canvas.toDataURL()}); 
            imageUrl = canvas.toDataURL();
        }


        return imageUrl;
    }
}
